import { render, staticRenderFns } from "./HeatVsAcPopUp.vue?vue&type=template&id=634e0f1c&"
import script from "./HeatVsAcPopUp.vue?vue&type=script&lang=js&"
export * from "./HeatVsAcPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports